import React from 'react';
import { MdGroup as ClassIcon } from 'react-icons/md';

export default [
  {
    collapse: true,
    name: 'Sách điện tử',
    miniName: 'T',
    icon: 'fas fa-book text-blue',
    layout: '/lms',
    exact: true,
    roles: ['teacher'],
    showInSidebar: true,
    sortOrder: 1,
    type: 'classLevel',
    views: new Array(13)
      .fill('')
      .map((item, index) => {
        // lớp 1 -> lớp 12, Lớp 0 = Mầm non 1, 2, 3.
        const className = index;
        return {
          path: `/teacher/books/:${className}`,
          name: `${className === 0 ? 'Mầm non' : `Lớp ${className}`}`,
          miniName: 'B',
          component: React.lazy(() => import('pages/Teacher/Books')),
          layout: '/lms',
          exact: true,
          roles: ['authenticated'],
          showInSidebar: true,
          sortOrder: index,
        };
      })
      .concat([
        {
          path: '/teacher/books/:archive',
          name: 'Lưu trữ',
          miniName: 'T',
          component: React.lazy(() => import('pages/Teacher/Books')),
          layout: '/lms',
          exact: true,
          roles: ['authenticated'],
          showInSidebar: true,
          sortOrder: 13,
        },
      ]),
  },
  // { // Route dành riêng cho tài khoản "joya.dolly@gmail.com" id === 40515 là mở tất cả sách
  //   path: '/teacher/allbooks',
  //   name: 'Sách điện tử',
  //   miniName: 'T',
  //   component: Teacher_Books,
  //   icon: 'fas fa-book text-blue',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  //   sortOrder: 1,
  //   showInSidebar: true,
  // },

  {
    path: '/teacher/classes',
    name: 'Quản lý lớp học',
    miniName: 'C',
    component: React.lazy(() => import('pages/Teacher/Classes/Classes')),
    icon: <ClassIcon size={20} className='tw-text-yellow-500' />,
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
    showInSidebar: true,
    sortOrder: 2,
  },
  {
    path: '/teacher/classes/:classId',
    component: React.lazy(() => import('pages/Teacher/Classes/ClassDetails')),
    icon: <ClassIcon />,
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },
  {
    path: '/teacher/classes/:classId/add-student',
    name: 'Thêm học sinh',
    miniName: 'C',
    icon: 'ni ni-hat-3',
    component: React.lazy(() => import('modules/TeacherModule/AddStudentsToClass/index')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
    showInSidebar: false,
    sortOrder: 0,
  },

  // worksheet space
  {
    path: '/teacher/worksheet/:id',
    component: React.lazy(() => import('modules/WorkSheet/WorkSheetPage')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },
  {
    path: '/teacher/worksheet/:id/edit/:worksheetId',
    component: React.lazy(() => import('modules/WorkSheet/WorkSheetPage')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },
  {
    path: '/teacher/worksheet/exercise/:id',
    component: React.lazy(() => import('modules/WorkSheet/CanvasToolPlus/ExcercisePage')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },
  {
    path: '/teacher/worksheet/exercise/:id/:studentId',
    component: React.lazy(() => import('modules/WorkSheet/CanvasToolPlus/ExcercisePage')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },
];
